const config = {
  API_BASE_URL: "https://www.haveli.com.pk/backend/public",
  STORAGE_URL: "https://www.haveli.com.pk/backend/public/storage"

};

export default config;